import { useState } from "react"
import { G500LiteAuthInfoType } from "../../feature/type/AuthInfoType"
import { initG500LiteAuthInfo } from "../../../common/const/commonConst";

/**
 * 再登録時に入力するG500Liteログイン情報の状態管理用カスタムフック
 */
export const useStateG500LiteReregistrationAuthInfo = () => {
    const [g500LiteReregistrationAuthInfo, setG500LiteReregistrationAuthInfo] = useState<G500LiteAuthInfoType>(initG500LiteAuthInfo);

    return {
        g500LiteReregistrationAuthInfo,
        setG500LiteReregistrationAuthInfo
    }
}